// src/components/dashboard/InheritanceCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/inheritanceCard.css';

const InheritanceCard = () => {
  return (
    <div className="col-xl-12 col-lg-12">
      <div className="inheritance-card card border-0 shadow-sm mb-0">
        <div className="card-body p-4">
          <div className="inheritance-content">
            <div className="inheritance-title">
              ENDOWMENT-CENTER
            </div>
            
            <div className="inheritance-main">
              <div>
                <h5 className="inheritance-heading">Create a Endowment for emergencies</h5>
                <p className="inheritance-text">
                  Organize critical information for your beneficiaries in case of emergency.
                </p>
              </div>
              
              <div className="inheritance-action">
                <Link 
                  to="/endowment-centre" 
                  className="btn-manage-endowment"
                >
                  <i className="fas fa-cog mr-2"></i> Manage Endowment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InheritanceCard;